module.exports = __webpack_public_path__ + "static/radish-58297dcbfb8ac4d8e2057fab5975f06c.svg";